import React, { PropsWithChildren } from 'react'

export type TableProps = PropsWithChildren<{
  className?: string
}>

const Table = ({ children, className }: TableProps) => {
  return <div className={className}>{children}</div>
}

export default Table
